import {
  IPerson,
  ICityOfResidence,
  RoleUser,
  StrNum
} from "interfaces/intarfaces";

type TKeyPerson = keyof IPerson;
export interface IResult {
  [propName: string]: any;
}

export const Comparator = (
  newData: Partial<IPerson>,
  oldData: Partial<IPerson>,
  user_type: RoleUser
): IResult => {
  const resultData: IResult = {};
  let fields: Partial<TKeyPerson>[] = [
    "user_id",
    "first_name",
    "last_name",
    "phone_code",
    "phone_number",
    "gender",
    "spoken_languages",
    "default_language",
    "description",
    "privacy",
    "user_type"
  ];

  fields = [
    ...fields,
    ...(user_type === "student"
      ? [
          "birth_date",
          "birth_country",
          "preferred_move_in",
          "preferred_move_out",
          "latitude",
          "longitude",
          "search_location_string",
          "max_budget",
          "min_area",
          "city_of_residence",
          "study",
          "past_experience",
          "autonomy"
        ]
      : ["requested_autonomy"])
  ] as Partial<TKeyPerson>[];
  const toLineObj = (x: ICityOfResidence | undefined) => {
    if (x === undefined || x === null) return "";
    return x.city + x.province + x.country;
  };
  const toLineArray = (x: string[] | undefined) => {
    if (x === undefined || x === null) return "";
    return x.sort().join();
  };
  for (let field of fields) {
    if (Object.keys(oldData).includes(field)) {
      if (
        field === "city_of_residence" &&
        toLineObj(newData[field]) === toLineObj(oldData[field])
      ) {
        continue;
      } else if (
        (field === "spoken_languages" || field === "past_experience") &&
        toLineArray(newData[field]) === toLineArray(oldData[field])
      ) {
        continue;
      } else if (
        newData[field] === oldData[field] ||
        ((newData[field] === "" || newData[field] === undefined) &&
          oldData[field] === null)
      ) {
        continue;
      } else if (
        (String(newData[field])?.length === 0 &&
          String(oldData[field])?.length === 0) ||
        (field === "max_budget" && String(newData[field]) === "0")
      )
        continue;
    } else if (field === "past_experience" && newData[field]?.length === 0)
      // If choose nothing insert None
      resultData["past_experience"] = ["None of the above"];
    else if (field === "spoken_languages" && newData[field]?.length === 0)
      continue;
    else if (
      field === "city_of_residence" &&
      (newData[field]?.province === undefined ||
        newData[field]?.city === undefined)
    )
      continue;
    else if (!newData[field] || String(newData[field])?.length === 0) continue;

    if (field === "past_experience" && newData[field]?.length === 0)
      resultData["past_experience"] = ["None of the above"];
    else resultData[field] = newData[field] || null;
  }
  if (Object.keys(resultData).includes("max_budget"))
    resultData["max_budget"] =
      resultData["max_budget"] === null
        ? null
        : Number(resultData["max_budget"]);
  return resultData;
};

export const isValue = (x: StrNum): boolean => {
  if (x === undefined) return false;
  if (x === null) return false;
  if (typeof x === "string" && x.length === 0) return false;
  if (typeof x === "number" && x === 0) return false;
  return true;
};
